import { create } from 'zustand';
import { Socket } from 'socket.io-client';

export interface IRoom {
  room_id: string;
  clid: string; // uk for the room id
  customer_key: string;
  device_model: string;
  city: string;
  app_id: string;
  ip: string;
  subscribers?: string[];
}

export type ScreenshotEvent = {
  checksum: string;
  screenshot: string;
  timestamp: number;
  elementsData: {
    displaySize: string; // {width, height}
    clickableElements: Array<any>;
  };
};

export type RawEvent = {
  checksum: string;
  timestamp: number;
  eventData: Record<string, string>; // ctp body
};

interface IConnectionData {
  isConnected: boolean;
  socket: Socket | null;
  screenshots: ScreenshotEvent[];
  rawData: RawEvent[];
  roomList: { rooms: IRoom[]; conn_without_room?: IRoom[] };
  setSocket: (socket: Socket | null) => void;
  setIsConnected: (isConnected: boolean) => void;
  setScreenshots: (screenshots: ScreenshotEvent[]) => void;
  setRawData: (rawItem: RawEvent) => void;
  setRoomList: (roomList: { rooms: IRoom[]; conn_without_room?: IRoom[] }) => void;
  reset: () => void;
  clearTimeline: () => void;
  clearScreenshots: () => void;
}

export const useConnectionData = create<IConnectionData>((set) => ({
  isConnected: false,
  socket: null,
  screenshots: [],
  rawData: [],
  roomList: { rooms: [], conn_without_room: [] },
  reset: () => set(() => ({ screenshots: [], rawData: [] })),
  clearTimeline: () => set(() => ({ rawData: [] })),
  clearScreenshots: () => set(() => ({ screenshots: [] })),
  setIsConnected: (isConnected: boolean) => set(() => ({ isConnected })),
  setSocket: (socket: Socket | null) => set(() => ({ socket })),
  setScreenshots: (screenshots: ScreenshotEvent[]) => set(() => ({ screenshots })),
  setRawData: (raw: RawEvent) =>
    set((state) => ({ rawData: [raw, ...state.rawData].slice(0, 500) })),
  setRoomList: (roomList: { rooms: IRoom[]; conn_without_room?: IRoom[] }) =>
    set(() => ({ roomList })),
}));
